import { Dialog } from './dialog.js';
import { Pointer } from './pointer';
import { Socket } from './socket.js';
import { Viewport } from './viewport';

const viewport = document.querySelector('main');

Dialog.init();
Pointer.init(viewport);
Socket.init();
Viewport.init(viewport);
